<template>
  <v-row
    class="map-popup__container"
    no-gutters
  >
    <v-col cols="4">
      <v-img :lazy-src="image"/>
    </v-col>
    <v-col cols="8" class="map-popup__text-container">
      <strong class="map-popup__title">{{ name }}</strong>
      <p>{{ content }}</p>
      <p>
        <router-link
          v-if="isOnline"
          class="map-popup__link"
          :to="link"
        >
          {{ $t('messages.know-more') }}
        </router-link>
      </p>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'MapPopup',

    props: {
      poi: {
        required: true,
        type: Object,
      },

      showLink: {
        default: true,
        type: Boolean
      }
    },

    computed: {
      locale() {
        return this.$store.state.locale
      },

      name() {
        return this.poi.business_content[this.locale]?.name
      },

      content() {
        const { description } = this.poi.business_content[this.locale]
        return description && description.length > 130
          ? `${description.slice(0, 125)}...`
          : description
      },

      image() {
        return this.poi.image && this.poi.image.cover || this.$store.state.objects.defaultImages.cover
      },

      link() {
        const { locale, poi } = this

        const link = { name: 'DetailPage', params: { locale, slug: poi.slug[locale] } }

        return link
      },

      isOnline() {
        return this.$store.state.isOnline
      },
    },
  }
</script>

<style lang="sass" scoped>
  ::v-deep .leaflet-popup-content-wrapper
    border-radius: 0 !important

  ::v-deep .v-image__image--preload
    filter: none
</style>
